<div #gridRefScroll class="mibi-panel"
    (mousedown)="onScrollContainerMouseDown($event)"
>
    <div class="mibi-panel__overflow"
        (mousedown)="onContainerMouseDown($event)"
    ></div>
    <!-- this additional container for the grid improves the overall performance, do NOT remove -->
    <div class="mibi-panel__content">
        <div #grid class="mibi-grid"
            [ngStyle]="{
                'grid-template-columns': gridTemplateColumns,
                'grid-auto-rows': 'min-content'
            }"
            (mousedown)="onGridMouseDown($event)"
        >
            <ng-container *ngFor="let rowId of rows; let row=index">
                <mibi-data-grid-cell-view *ngFor="let colId of cols; let col=index"
                    [ngClass]="{
                        'mibi-grid__cell': !isHeader(row, col),
                        'mibi-grid__sticky': isHeader(row, col),
                        'mibi-grid__sticky--top': isColHeader(row, col),
                        'mibi-grid__sticky--left': isRowHeader(row, col),
                        'mibi-grid__sticky--top-left': isGridHeader(row, col)
                    }"
                    [mibiDataGridDirtyEmitter]="getCellDirtyEmitter(rowId, colId)"
                    [controller]="cellController" 
                    [row]="row"
                    [col]="col"
                    (mouseover)="onCellMouseEvent($event, row, col)"
                    (mousedown)="onCellMouseEvent($event, row, col)"
                    (click)="onCellMouseEvent($event, row, col)"
                    (mouseup)="onCellMouseEvent($event, row, col)"
                    (mouseout)="onCellMouseEvent($event, row, col)"
                ></mibi-data-grid-cell-view>
            </ng-container>
        </div>
    </div>
    <mibi-data-grid-editor-view
        [mibiDataGridDirtyEmitter]="getEditorDirtyEmitter()"
        [controller]="cellController"
        (dataChange)="onEditorDataChange($event)"
        (confirm)="onEditorConfirm()"
        (cancel)="onEditorCancel()"
        (mouseover)="onEditorMouseEvent($event)"
        (mousedown)="onEditorMouseEvent($event)"
        (click)="onEditorMouseEvent($event)"
        (mouseup)="onEditorMouseEvent($event)"
        (mouseout)="onEditorMouseEvent($event)"
    ></mibi-data-grid-editor-view>
</div>
